import { PrinterDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { EventTemplatesDataResolver } from '../../../resolvers/event-template-data.resolver';
import { TemplatesCreateSchedulesCreateControllerModule } from './controllers/TemplatesCreateSchedulesCreateController';
import { TemplatesCreateSchedulesCreateFormsView } from './forms/forms';
import { TemplatesCreateSchedulesCreatePricingView } from './pricing/pricing';
import { TemplatesCreateSchedulesCreateTimesView } from './times/times';

export const TemplatesCreateSchedulesCreateView = angular
  .module('acme.view.application.templates.create.schedules.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    TemplatesCreateSchedulesCreateControllerModule,
    'acme.view.application.templates.create.schedules.create.times',
    TemplatesCreateSchedulesCreatePricingView,
    'acme.view.application.templates.create.schedules.create.resources',
    'acme.view.application.templates.create.schedules.create.tickets',
    TemplatesCreateSchedulesCreateFormsView,
    TemplatesCreateSchedulesCreateTimesView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.templates.create.schedules.create',
      url: '',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateSchedulesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '    ',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.create',
      url: '',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateSchedulesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '    ',
      },
      resolve: {
        EventTemplateData: EventTemplatesDataResolver({ noCache: true }),
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.edit',
      url: '/:scheduleId',
      abstract: true,
      views: {
        'subview-main@application.templates': {
          controller: 'TemplatesCreateSchedulesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: '    ',
      },
      resolve: {
        EventTemplateData: EventTemplatesDataResolver({ noCache: true }),
        PrinterData: PrinterDataResolver(),
      },
    });
  }).name;
